import $ from 'jquery';
/**
 * Activate collection sorting and filtering controls
 */ export const init = async function() {
    $('#js-collection-sorting').on('change', function changeSortOrder(evt) {
        const sortOrder = $(evt.delegateTarget).val();
        if (typeof sortOrder !== 'string' || !sortOrder) {
            return;
        }
        const uri = new URL(window.location.href);
        uri.searchParams.set('sort_by', sortOrder);
        window.location.href = uri.toString();
    });
    $('#js-collection-tag-filter').on('change', function filterByTag(evt) {
        const selector = $(evt.delegateTarget);
        const tag = selector.val();
        const urlTemplate = selector.attr('data-collection-url') || '/collections/all';
        if (typeof tag !== 'string' || !tag) {
            return;
        }
        const uri = new URL(window.location.href);
        uri.pathname = [
            urlTemplate,
            tag === 'nil' ? '' : tag
        ].join('/');
        window.location.href = uri.toString();
    });
};
